import React, {useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap';
import Spinner from '../../reusables/spinner';
import {connect} from 'react-redux';
import {delete_faq, get_faqs} from '../../../redux/actions/adminActions';
import CreateFaq from '../../modals/createFaq';

function Supplier({getFAQ, accessToken, quotes, deleteFAQ}) {

    const [active,
        setActive] = useState(null);

    const [create,
        setCreate] = useState(false);

    const [deleteModal,
        setDelete] = useState(false);

    const [edit,
        setEdit] = useState({id: null, modal: false});

    const [loading,
        setLoading] = useState(true);

    useEffect(() => {
        getFAQ('supplier', accessToken, () => setLoading(false));
    }, [quotes]);

    const handleDelete = () => {
        deleteFAQ(active, 'supplier', accessToken, () => {
            setDelete(false);``
            setActive(null);
        })
    }

    const clickHandler = (id) => {
        if (active === id) {
            setActive(null)
        } else {
            setActive(id)
        }
    }

    return (
        <div>
            <div className="isRelative">
                <button
                    className="btn__filled hasRadius textIsBold"
                    onClick={() => setCreate(true)}>Add New FAQ</button>

                <div className="mt-4">

                    {loading
                        ? <div className="center">
                                <Spinner/>
                            </div>

                        : quotes
                            ?.map(quote => (
                                <div className={`item__faq my-2 ${active === quote.id && 'active'}`}>
                                    <div className="header spaceBetween alignOnly">
                                        <div className="alignOnly">
                                            <input type="checkbox" name="" id=""/>
                                            <p
                                                className="sectionText mb-0 mx-2 isClickable"
                                                onClick={() => clickHandler(quote.id)}>{quote.question}</p>
                                        </div>

                                        <button
                                            className="btn__transparent--green btn__edit"
                                            onClick={() => setEdit({
                                            ...edit,
                                            id: quote.id,
                                            modal: true
                                        })}>Edit</button>
                                    </div>

                                    <div className="body pt-3">
                                        <p className="sectionText--small mb-0 w-70">
                                            {quote.answer}
                                        </p>
                                    </div>
                                </div>
                            ))
}

                </div>

                <div className="actionsHolder spaceBetween mt-5">
                    <button
                        className={`${active !== null
                        ? 'btn__red'
                        : 'btn__disabled'} hasRadius`}
                        disabled={active === null}
                        onClick={() => setDelete(true)}>Delete</button>
                </div>

            </div>
            <CreateFaq show={create} handleClose={() => setCreate(false)} supplier/>
            <CreateFaq
                show={edit.modal}
                id={edit.id}
                handleClose={() => setEdit({
                ...edit,
                modal: false
            })}
                supplier
                edit/>

            <Modal show={deleteModal} onHide={() => setDelete(false)} centered>
                <div
                    className="icon--tiny isClickable closeModal"
                    onClick={() => setDelete(false)}>
                    <i class="ri-close-line sectionText--small"></i>
                </div>
                <div className="sectionHeight--mid alignOnly">
                    <div className="w-100">
                        <h2 className="sectionText--mid vAlign">Are you sure you want to delete this faq?</h2>

                        <div className="center mt-3">
                            <button className='btn__transparent' onClick={ () => setDelete(false)}>No</button>
                            <button className='btn__filled hasRadius mx-2' onClick={ handleDelete }>Yes</button>
                        </div>
                    </div>

                </div>
            </Modal>

        </div>
    )
}   

const mapStateToProps = (state) => ({accessToken: state.admin.token, quotes: state.admin.faqs.supplier})

const mapDispatchToProps = (dispatch) => ({
    getFAQ: (type, token, success) => dispatch(get_faqs(type, token, success)),
    deleteFAQ: (id, type, token, success) => dispatch(delete_faq(id, type, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(Supplier)
